import { createMakeRequest } from '../../browser/client';

export function getRegions(query: string = '') {
  let request = createMakeRequest(window.__mainpage_api_host__ || window.location.host);

  return request({
    method: 'GET',
    uri: {
      path: '/cian-api/site/v1/search-regions-cities-simplified/?text=' + query,
    },
  }).then((response: IResponse) => {
    return response.data.items;
  });
}

export interface IRegion {
  id: number;
  displayName: string;
}

export interface IResponse {
  status: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}
